import { useState, useEffect } from "react";
import { useAdminApi } from "../adminUtils";

// value: "default" | "me" | "none" | signature _id
// Owners: studio signatures, "Me", or none. Teachers: "Me" (their own name + photo) or none.
export default function SignatureSelect({ value, onChange }) {
  const { API, AUTH, IS_OWNER, USER } = useAdminApi();
  const [sigs, setSigs] = useState([]);

  useEffect(() => {
    if (!IS_OWNER) return;
    fetch(`${API}/signatures`, { headers: AUTH })
      .then(r => r.json()).then(d => setSigs(d.signatures ?? []))
      .catch(() => setSigs([]));
  }, [API, AUTH, IS_OWNER]);

  // Teachers can't use the studio's signatures
  useEffect(() => {
    if (!IS_OWNER && value !== "me" && value !== "none") onChange("me");
  }, [IS_OWNER, value, onChange]);

  const meOption = <option value="me">Me — {USER?.name || "whoever is signed in"}</option>;

  if (!IS_OWNER) {
    return (
      <select className="adm-input" value={value === "none" ? "none" : "me"} onChange={e => onChange(e.target.value)}>
        {meOption}
        <option value="none">No signature</option>
      </select>
    );
  }

  const def = sigs.find(s => s.isDefault);

  return (
    <select className="adm-input" value={value || "default"} onChange={e => onChange(e.target.value)}>
      <option value="default">{def ? `Default — ${def.label} (${def.name})` : "Default (none set up yet)"}</option>
      {sigs.map(s => <option key={s._id} value={s._id}>{s.label} — {s.name}</option>)}
      {meOption}
      <option value="none">No signature</option>
    </select>
  );
}
